import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { injectIntl, intlShape } from 'react-intl';

import { getSessionExpired } from './authSelectors';
import { getLoginButtonStatus } from '../localeCurrencyPicker/LocaleCurrencyPickerSelector';
import { dismissSessionExpired } from './authModule';
import authMessages from './message/AuthMessage';




export const SessionExpiredBanner = (props) => {
    const { visible, onDismiss, intl } = props;
    const alertRef = useRef(null);

    
    
    
    useEffect(() => {
        const node = alertRef.current;
        if (visible && node && typeof node.scrollIntoView === 'function') {
            node.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [visible]);

    return (
        <Collapse in={visible} unmountOnExit className="session-expired-banner-wrapper">
            <Alert
                ref={alertRef}
                severity="error"
                variant="outlined"
                role="alert"
                className="session-expired-banner"
                onClose={onDismiss}
                closeText={intl.formatMessage(authMessages.dismissSessionExpired)}
            >
                {intl.formatMessage(authMessages.sessionExpired)}
            </Alert>
        </Collapse>
    );
};

SessionExpiredBanner.propTypes = {
    visible: PropTypes.bool.isRequired,
    onDismiss: PropTypes.func.isRequired,
    intl: intlShape.isRequired
};



export const mapStateToProps = state => ({
    visible: getSessionExpired(state) && getLoginButtonStatus(state)
});

export const mapDispatchToProps = {
    onDismiss: dismissSessionExpired
};

export const ConnectedSessionExpiredBanner = connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(SessionExpiredBanner));

export default ConnectedSessionExpiredBanner;
